export default {
  beforeMount() {
    this.$recaptchaInstance?.showBadge();
  },
  beforeDestroy() {
    this.$recaptchaInstance?.hideBadge();
  }
};
